import { LOCATIONS } from "../shared/tagTypes";
import { baseApi } from "./base";

const locationApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [LOCATIONS],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getLocations: builder.query({
                query: (payload) => ({
                    url: "/locations",
                    params: {
                        ...(payload.type && { type: payload.type }),
                        ...(payload.parentId && { parentId: payload.parentId })
                    }
                }),
                providesTags: [LOCATIONS],
            }),
            getDivisions: builder.query({
                query: () => ({
                    url: "/locations/divisions",
                }),
                providesTags: [LOCATIONS],
            }),
            getDistricts: builder.query({
                query: (payload) => ({
                    url: "/locations/districts",
                    params: {
                        ...(payload.divisionId && { divisionId: payload.divisionId })
                    }
                }),
                providesTags: [LOCATIONS],
            }),
            getThanas: builder.query({
                query: (payload) => ({
                    url: "/locations/thanas",
                    params: {
                        ...(payload.districtId && { districtId: payload.districtId })
                    }
                }),
                providesTags: [LOCATIONS],
            }),
            getAreas: builder.query({
                query: (payload) => ({
                    url: "/locations/areas",
                    params: {
                        ...(payload.thanaId && { thanaId: payload.thanaId })
                    }
                }),
                providesTags: [LOCATIONS],
            }),
            createLocation: builder.mutation({
                query: (payload) => ({
                    url: "/locations",
                    method: "POST",
                    body: payload,
                }),
                invalidatesTags: [LOCATIONS],
            }),
            updateLocation: builder.mutation({
                query: (payload) => ({
                    url: `/locations/${payload.id}`,
                    method: "PUT",
                    body: payload.body,
                }),
                invalidatesTags: [LOCATIONS],
            }),
            deleteLocation: builder.mutation({
                query: (payload) => ({
                    url: `/locations/${payload.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: [LOCATIONS],
            }),
        }),

        overrideExisting: false,
    });

export const {
    useGetLocationsQuery,
    useLazyGetLocationsQuery,
    useGetDivisionsQuery,
    useLazyGetDivisionsQuery,
    useGetDistrictsQuery,
    useLazyGetDistrictsQuery,
    useGetThanasQuery,
    useLazyGetThanasQuery,
    useGetAreasQuery,
    useLazyGetAreasQuery,
    useCreateLocationMutation,
    useUpdateLocationMutation,
    useDeleteLocationMutation
} = locationApi;
